import { render, staticRenderFns } from "./DeleteCategoryItemDialog.vue?vue&type=template&id=4f5660c6&scoped=true&"
import script from "./DeleteCategoryItemDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteCategoryItemDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5660c6",
  null
  
)

export default component.exports